const NES_DIALOG_TRANSLATIONS = {
  nl: {
    close: "Sluit dialoogvenster",
  },
  en: {
    close: "Close dialog",
  },
};

export { NES_DIALOG_TRANSLATIONS as N };
